import React from 'react';

function FormField({ label, error, hint, required, children }) {
  return (
    <div className="admin-form-group">
      {label && (
        <label className="admin-form-label">
          {label}
          {required && <span style={{ color: 'var(--admin-error)', marginLeft: '2px' }}>*</span>}
        </label>
      )}
      {children}
      {error && <p style={{ margin: '4px 0 0', fontSize: '11px', color: 'var(--admin-error)' }}>{error}</p>}
      {hint && !error && <p style={{ margin: '4px 0 0', fontSize: '11px', color: 'var(--admin-text-muted)' }}>{hint}</p>}
    </div>
  );
}

export default FormField;
